import { type WorkerRequirement } from "../api/types";

interface IsRequirementInstantReviewProps {
  workerRequirement?: WorkerRequirement;
}

export function isRequirementInstantReview(props: IsRequirementInstantReviewProps) {
  const { workerRequirement } = props;
  const {
    isAutomatedVerificationDecision,
    helloSignConfig,
    pandaDocConfig,
    resubmissionDisabledFor,
  } = workerRequirement?.requirement?.attributes ?? {};

  const isResubmissionDisabled =
    workerRequirement?.status &&
    resubmissionDisabledFor?.statuses?.includes(workerRequirement.status);
  return Boolean(
    !isResubmissionDisabled &&
    isAutomatedVerificationDecision &&
    (helloSignConfig?.isEmbeddedFlowEnabled || pandaDocConfig?.templateId)
  );
}
